import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setInputValidation, getInputData } from '../../store/forms';
import doValidations from './doValidations';

const useLoginValidation = (saveValidation) => {
	const [valid, setValid] = useState(true);

	const view = "login";
	const object = "checkinLogin";
	const reservationNumber = useSelector(getInputData(view, object, "reservationNumber"));
	const authorizationCode = useSelector(getInputData(view, object, "authorizationCode"));

	const dispatch = useDispatch();
	const handleValidation = (id, valid, text) => {
		if (saveValidation) {
			dispatch(setInputValidation({ validation: { valid, text }, object, input: id, view }));	
		}
	};
	const notNullString = (string) => string !== '';
	const validations = [
		{
			id: 'reservationNumber',
			text: 'Ingrese su número de reserva',
			valid: () => notNullString(reservationNumber.data),
		},
		{
			id: 'authorizationCode',
			text: 'Ingrese su código de autorización web',
			valid: () => notNullString(authorizationCode.data),
		},
	];
	useEffect(() => {
		doValidations(validations, setValid, handleValidation);
	}, [reservationNumber.data, authorizationCode.data]); // eslint-disable-line react-hooks/exhaustive-deps
	return valid;
}

export default useLoginValidation;
